const UNIT_SECONDS = { seconds: 1, minute: 60, minutes: 60, hours: 3600, days: 86400 };

// Round floating point noise from conversions such as 1 second to minutes
// and back, keeping API durations accurate to a microsecond.
export const toSeconds = duration => Number((Number(duration?.value) * (UNIT_SECONDS[duration?.unit] || 0)).toFixed(6));

export const convertDurationUnit = (duration, unit) => {
  const previousFactor = UNIT_SECONDS[duration.unit];
  const nextFactor = UNIT_SECONDS[unit];
  if (duration.value === "" || !Number.isFinite(Number(duration.value)) || !previousFactor || !nextFactor) {
    return { ...duration, unit };
  }
  return { ...duration, unit, value: String(toSeconds(duration) / nextFactor) };
};
